import { Play } from '@arpeggi/shared'
import { silentAuthenticatedPost } from '../../hooks/useAuth'

const usePlaysAPI = () => {
  const createPlay = async (arpMediaId: number) => {
    const { data } = await silentAuthenticatedPost<Play>(`/api/v2/arp-media/${arpMediaId}/plays`)

    return data
  }

  const endPlay = async (dto: { playId: number; playTimeMs: number }) => {
    const { data } = await silentAuthenticatedPost<Play>('/webhooks/play-ended', dto)

    return data
  }

  return {
    createPlay,
    endPlay
  }
}

export default usePlaysAPI
